import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-main-option-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './main-option-button.component.html',
  styleUrl: './main-option-button.component.scss',
})
export class MainOptionButtonComponent {
  @Input() label = '';
  @Input() iconPathForActiveButton = '';
  @Input() iconPathForInActiveButton = '';
  @Input() isActive = false;
}
